import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { authApi } from '../features/auth/authApi';
import { toast } from 'sonner';

export function ResetPasswordPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [logoUrl, setLogoUrl] = useState('https://inteligenciaenegocios.com.br/assets/logo.jpg');

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const domain = window.location.hostname;
        const info = await authApi.tenantInfo(domain);
        if (info && info.logo_url) {
          setLogoUrl(info.logo_url);
        }
      } catch (err) {
        console.error('Failed to fetch tenant info', err);
      }
    };
    fetchLogo();
  }, []);

  useEffect(() => {
    if (!token) {
      toast.error('Token de redefinição inválido ou ausente.');
    }
  }, [token]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token) {
      toast.error('Token inválido.');
      return;
    }
    if (password !== confirmPassword) {
      toast.error('As senhas não coincidem.');
      return;
    }
    if (password.length < 8) {
      toast.error('A senha deve ter pelo menos 8 caracteres.');
      return;
    }

    setIsSubmitting(true);
    try {
      await authApi.resetPassword({ token, password });
      setSuccess(true);
      toast.success('Senha redefinida com sucesso!');
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err: any) {
      toast.error(err.message || 'Erro ao redefinir a senha. O token pode estar expirado.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="mesh-gradient-bg">
        <div className="mesh-orb mesh-orb-1" />
        <div className="mesh-orb mesh-orb-2" />
        <div className="mesh-orb mesh-orb-3" />
      </div>

      <div className="login-card glass-panel">
        <div className="login-brand">
          <div className="logo-container">
            <img src={logoUrl} alt="Logo" className="brand-image" />
          </div>
        </div>

        {!token ? (
          <>
            <div className="login-header">
              <span className="eyebrow-premium">Atenção</span>
              <h1 className="login-title">Link Inválido</h1>
              <p className="login-subtitle">Não foi possível encontrar o token de redefinição.</p>
            </div>
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <Link to="/login" className="premium-button" style={{ textDecoration: 'none', display: 'inline-block' }}>
                Voltar ao Login
              </Link>
            </div>
          </>
        ) : (
          <>
            <div className="login-header">
              <span className="eyebrow-premium">Segurança</span>
              <h1 className="login-title">Redefinir Senha</h1>
              <p className="login-subtitle">Crie uma nova senha para o seu acesso</p>
            </div>

            {success ? (
              <div style={{ textAlign: 'center' }}>
                <p style={{ marginBottom: '1.5rem', color: 'var(--success-color, #10b981)', fontWeight: 500 }}>
                  Sua senha foi redefinida com sucesso. Redirecionando para o login...
                </p>
                <button className="premium-button" onClick={() => navigate('/login')}>
                  Ir para o Login
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="form-stack">
                <div className="form-field">
                  <label htmlFor="password" className="field-label">Nova Senha</label>
                  <input
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Mínimo 8 caracteres"
                    disabled={isSubmitting}
                    autoFocus
                    required
                    className="premium-input"
                  />
                </div>
                <div className="form-field">
                  <label htmlFor="confirmPassword" className="field-label">Confirmar Nova Senha</label>
                  <input
                    id="confirmPassword"
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Repita a senha"
                    disabled={isSubmitting}
                    required
                    className="premium-input"
                  />
                </div>
                <button type="submit" className="premium-button" disabled={isSubmitting}>
                  {isSubmitting ? (
                    <span className="btn-loading">
                      <span className="spinner-sm" />
                      Salvando...
                    </span>
                  ) : (
                    'Redefinir Senha'
                  )}
                </button>
              </form>
            )}
          </>
        )}

        <p className="login-footer text-center">CRM Platform Suite</p>
      </div>
    </div>
  );
}
